export function anchorsCompanies() {
    const companiesListingItems = $('.companies-listing .item');
    const companiesFilter = $('.companies-filter');


    companiesListingItems.each((i, item) => {
        const title = $(item).find('.category').text().toLowerCase().split(/[ ,]+/).join('-');
        $(item).attr('id', title);
    });


    companiesFilter.find('a').each((i, item) => {
        const title = $(item).find('span').text().toLowerCase().split(/[ ,]+/).join('-');
        $(item).attr('href', '#' + title);
        $(item).on('click', function (e) {
            e.preventDefault();
            const $target = $(this).attr("href");
            $("html, body").animate({scrollTop: $($target).offset().top - $(".header").innerHeight() - 20}, 1000);
            if ($(window).width() < 1024) {
                $('.companies-filter.open').toggleClass('open')
                if ($('body').hasClass('overflow')) {
                    $('body').removeClass('overflow')
                }
            }

        })
    });


    if ($(window).width() < 1024) {
        $('.companies-filter .subtitle-decor').click(function (e) {
            let thisParent = $(this).parent().parent();
            thisParent.toggleClass('open');
            $('body').toggleClass('overflow');
        })
    }

    function toggleActiveOnScroll() {
        const $window = $(window);
        const windowScrollTop = $window.scrollTop();
        const headerHeight = $(".header").innerHeight();
        companiesListingItems.each(function (index, item) {
            let $this = $(item);
            let itemOffsetTop = $this.offset().top;
            if (windowScrollTop >= itemOffsetTop - headerHeight - 30) {
                let $fidID =
                    companiesFilter.find(`a[href="#${$this.attr('id')}"]`).parent().addClass('active').siblings().removeClass('active');
            }
        })
    }

    window.addEventListener("load", function () {
        toggleActiveOnScroll();
    });

    window.addEventListener("scroll", function () {
        toggleActiveOnScroll();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/anchorsCompanies.js